export default function queueReducer(queue, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...queue, [action.type]: action.value ? Number(action.value).toString() : "" };
    case "maxlen":
    case "weight":
    case "ringSeconds":
    case "timeout":
    case "wrapUpTime":
    case "periodicAnnounceFrequency":
    case "announceFrequency":
    case "minAnnounceFrequency":
      return { ...queue, [action.type]: action.value ? Number(action.value) : null };
    case "announce":
      return { ...queue, [action.type]: action.value ? action.value : "no" };
    case "joinAnnounce":
      return { ...queue, [action.type]: action.value ? action.value : null };
    case "musiconhold":
      return { ...queue, [action.type]: action.value === "Ringing" ? null : action.value };
    case "periodicAnnounce": {
      if (!queue.periodicAnnounceFrequency && action.value !== null) {
        return { ...queue, periodicAnnounceFrequency: 30, [action.type]: action.value !== null ? action.value : null };
      } else if (action.value === null) {
        return {
          ...queue,
          periodicAnnounceFrequency: null,
          [action.type]: action.value !== null ? action.value : null,
        };
      } else {
        return { ...queue, [action.type]: action.value !== null ? action.value : null };
      }
    }
    case "announceHoldtime":
      queue[action.type] = action.value;

      if (queue.announceFrequency === null && (queue.announcePosition !== "no" || action.value !== "no")) {
        return { ...queue, [action.type]: action.value, announceFrequency: 40 };
      } else if (queue.announcePosition === "no" && action.value === "no") {
        return { ...queue, [action.type]: action.value, announceFrequency: null };
      } else {
        return { ...queue, [action.type]: action.value };
      }
    case "announcePosition":
      if (queue.announceFrequency === null && (queue.announceHoldtime !== "no" || action.value !== "no")) {
        return { ...queue, [action.type]: action.value, announceFrequency: 40 };
      } else if (queue.announceHoldtime === "no" && action.value === "no") {
        return { ...queue, [action.type]: action.value, announceFrequency: null };
      } else {
        return { ...queue, [action.type]: action.value };
      }

    case "addMember":
      return {
        ...queue,
        members: [
          ...queue.members,
          {
            exten: action.member.exten,
            paused: null,
            lock: action.state === "unlock" ? 0 : 1,
            uniqueid: action.id,
          },
        ],
      };
    case "removeMember":
      return { ...queue, members: queue.members.filter((queueMember) => queueMember.exten !== action.member.exten) };
    case "toggleMemberLock": {
      return {
        ...queue,
        members: queue.members.map((queueMember) => {
          if (queueMember.exten === action.member.exten) {
            queueMember.lock = action.status === 1 ? 0 : 1;
            queueMember.paused = 0;
          }

          return queueMember;
        }),
      };
    }

    default:
      return { ...queue, [action.type]: action.value };
  }
}
